import { createContext } from "react";

type ContextObject = Record<string, unknown>;
type ContextId = string | number;

export interface GlobalContextValue {
  isLoggedIn?: boolean;
  loggedInUser?:
    | ({
        id?: ContextId;
        role?: string;
      } & ContextObject)
    | null;
  loggedInUserRole?: string;
  selectedBrand?:
    | ({
        id?: ContextId;
      } & ContextObject)
    | null;
  userBrands?: ContextObject[];
}

export type LoaderContextValue = (_show: boolean) => void;

export const GlobalContext = createContext<GlobalContextValue>(
  undefined as unknown as GlobalContextValue
);
export const LoaderContext = createContext<LoaderContextValue>(
  undefined as unknown as LoaderContextValue
);
